import { DOWNLOAD_FILE } from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const downloadReportForS3Link = (requestId) => {
  const requestURL = DOWNLOAD_FILE;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {request_id: requestId},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
